import styled from 'styled-components';

export default styled.div`
  align-items: center;
  display: inline-flex;
  line-height: 64px;
  padding: 0 10px;
  vertical-align: middle;
`;
